import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyLetters]',
})
export class OlnlyLettersDirective {
  // This regex matches only letters (both uppercase and lowercase) and spaces
  private regex: RegExp = new RegExp(/^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$/);
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    ' ',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (!this.regex.test(next)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;
    if (!this.regex.test(value)) {
      inputElement.value = value.replace(/[^a-zA-ZÀ-ÿ\u00f1\u00d1 ]/g, ''); // Remove invalid characters
    }
  }
}
